import { z } from 'zod';
import { createPaginatedSchema, paginationQueryParamsSchema } from '../common/index.js';
import { propertySchema } from '../property/index.js';
import { UserBookmarkStatusEnum } from './base.js';
export const userPropertySchema = propertySchema.extend({
    status: z.enum(UserBookmarkStatusEnum),
    date: z.iso.datetime(),
});
export const paginatedUserPropertySchema = createPaginatedSchema(userPropertySchema);
export const userPropertyQueryParamsSchema = paginationQueryParamsSchema.extend({
    status: z.enum(UserBookmarkStatusEnum).optional(),
});
